import * as yup from 'yup'
import { Types } from 'service-api'

import { i18WithDefault as t } from '@shared/locale'

export const contactSchema = yup.object({
  name: yup.string().max(140).required().label(t('profile.contacts.form.displayName')),
  type: yup
    .object({
      id: yup.string(),
      label: yup.string(),
    })
    .required()
    .typeError(t('global.error.invalidValue'))
    .label(t('profile.contacts.form.type')),
  phone: yup.string().required().label(t('profile.contacts.form.phone')),
  description: yup.string().label(t('profile.contacts.form.description')),
})

export type TContactSchema = yup.InferType<typeof contactSchema>

export const contactTypeOptions = [
  { id: 'OWNER', label: t('profile.contacts.type.owner') },
  { id: 'EMERGENCY', label: t('profile.contacts.type.emergency') },
  { id: 'VET', label: t('profile.contacts.type.vet') },
  { id: 'OTHER', label: t('profile.contacts.type.other') },
]

export const getLabelFromContactType = (type: string) => {
  return contactTypeOptions.find((ct) => ct.id === type)?.label || contactTypeOptions[3].label
}

export const getContactTypeFromValue = (value?: string | null) => {
  // const defaultValue = contactTypeOptions[0]
  if (!value) {
    return null
  }
  return contactTypeOptions.find((ct) => ct.id === value) || null // defaultValue
}

export const setupInitialValues = (contact?: Types.AssociatedContactClientDto) => {
  return {
    name: contact?.displayName || '',
    type: getContactTypeFromValue(contact?.type),
    phone: contact?.phone || '',
    description: contact?.description || '',
  } as unknown as TContactSchema
}
